import { BrowserRouter as Router ,Routes,Route   } from "react-router-dom";
import App from "../App";

import Invite from '../views/invite/Index'
import St from '../views/invite/st'
import Mint from '../views/invite/Mint'
import Mintt from '../views/invite/Mintt'
import MinttTest from '../views/invite/MinttTest'
import Airdrop from '../views/invite/Airdrop'
import Nft from '../views/invite/Nft'
import Box from '../views/invite/Box'
import Pledge from '../views/pledge/Index'
import Staking from '../views/pledge/Staking'
import My from '../views/my/Index'
import Usdt from '../views/my/Usdt'
import AssetTest from '../views/my/IndexTest'
import AssetTest1 from '../views/my/IndexTes1'
import LiuShuiUsdt from '../views/liushui/IndexUsdt'
import LiuShuiMeba from '../views/liushui/IndexMeba'
import LiuShuiMarsx from '../views/liushui/IndexMarsx'
import LiushuiSpacexMint  from "../views/liushui/IndexSpacexMint";
import LiushuiDogePledge  from "../views/liushui/IndexDogePledge";
import LiuShuiEth from '../views/liushui/IndexEth'
import MappingPro from '../views/my/Index'
import Pool from '../views/mapping/Pool'
import Game from '../views/game/game'
import Game1 from '../views/game/game1'
import Game160 from '../views/game/game160'
import Challenge from '../views/invite/Challenge'

// import Node from '../views/node/Index'
// import Hold from '../views/invite/Buyhero'
// import Up from '../views/invite/Up'
// import Job from '../views/invite/Job'
// import Hero from '../views/invite/Hero'
// import Boss from '../views/invite/Boss'
// import Ccer from '../views/pledge/ccer'
// import LiuShuiEth1 from '../views/liushui/IndexEth1'
// import Mapping from '../views/mapping/Index'
// import Mapping1 from '../views/mapping/Index1'
// import MappingEth from '../views/mapping/IndexEth'
// import Deposit from '../views/deposit/Index'
// import Swap from '../views/swap/Index'
// import Swap1 from '../views/swap/Index1'
// import Market from '../views/market/Index'
// import Web from '../views/web/Web'
// import Tr from '../views/tr/Index'
// import TrMy from '../views/tr/TrMy'



const BaseRouter = () => {
    
    return(
        <Router>
            
            <Routes>
                <Route path="/" element={<App/>}>
                     <Route path="/usdtspx" element={<Usdt/>}></Route> 
                     <Route index  element={<Box/>}></Route>
                   
                    {/* <Route path="/minttest" element={<MinttTest/>}></Route>
                    <Route path="/task" element={<Challenge/>}></Route>
                     <Route path="/usdtspx" element={<Usdt/>}></Route> 
                    <Route path="/game" element={<Game/>}></Route>
                    <Route path="/game1" element={<Game1/>}></Route>
                    <Route path="/game160" element={<Game160/>}></Route>
                    <Route path="/invite" element={<Invite/>}></Route>
                    <Route index  element={<Mintt/>}></Route>
                    <Route path="/airdrop" element={<Airdrop/>}></Route>
                    <Route path="/ecosystem" element={<St/>}></Route>
                    <Route path="/pledge" element={<Pledge/>}></Route>
                    
                    <Route path="/staking" element={<Staking/>}></Route>
                    <Route path="/my" element={<My/>}></Route>
                    <Route path="/nft" element={<Nft/>}></Route>
                    <Route path="/box" element={<Box/>}></Route>
            
                    <Route path="/record_usdt" element={<LiuShuiUsdt/>}></Route>
                    <Route path="/record_spacex" element={<LiuShuiMeba/>}></Route>
                  
                    <Route path="/record_bnb" element={<LiuShuiEth/>}></Route>
                    <Route path="/record_spacex_mint" element={<LiushuiSpacexMint/>}></Route>
                    <Route path="/record_doge_pledge" element={<LiushuiDogePledge/>}></Route>
             
                    <Route path="/asset" element={<AssetTest1/>}></Route>
                      <Route path="/assettest" element={<AssetTest/>}></Route>
                      <Route path="/assettest1" element={<AssetTest1/>}></Route>
                    <Route path="/pool" element={<Pool/>}></Route> */}



                  
                </Route>
          
                <Route path="*" element={<App/>}></Route>
            </Routes>
           

        </Router>
        
    )
}

export default BaseRouter;